'use client'

import { ContentForm } from 'features/generator/ContentForm'
import {
	qrNameFormConfig,
	TQrContentFormSection,
	welcomeScreenFormConfig,
} from 'features/generator/contentFormSections'
import { documentInfoFormConfig } from 'features/generator/contentFormSections/PdfForm/DocumentInfo'
import {
	pdfFileFormConfig,
	pdfIsDirectAtom,
} from 'features/generator/contentFormSections/PdfForm/PdfFile'
import { QR_TYPE, TContentFormProps } from 'features/generator/generatorTypes'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'

import { contentDesignFormConfig } from '@/content-from-sections/client'

export const PdfContentForm = (props: TContentFormProps) => {
	const t = useTranslations()
	const isDirect = useAtomValue(pdfIsDirectAtom)

	const config = {
		formSectionList: [
			pdfFileFormConfig(t),
			contentDesignFormConfig(t, undefined, isDirect),
			documentInfoFormConfig(t, isDirect),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm config={config} qrType={QR_TYPE.Pdf} {...props} />
}
